import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'
import 'firebase/compat/firestore'
import 'firebase/compat/database'

import { CONFIG } from '../firebase_config'

const firebaseApp = firebase.initializeApp(CONFIG)
export const db = firebaseApp.database()